



























import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import Snackbar from '../../molecules/Snackbar.vue'
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const dialogUpdateInfor = computed(() => displayui.dialogUpdateCompanyInfor);
    const openUpdateInfordialog = computed(() => displayui.openDialogUpdateComInfor)
    const closeUpdateInfordialog = computed(() => displayui.closeDialogUpdateComInfor)
    const dialogUpdateInforCompany = async () => {
      await company.updateCompanyInfor();
      await displayui.closeDialogUpdateComInfor()
      await company.changeCompareTelephone()
      await company.getCompanyInfor()
    }
    
    return {
      dialogUpdateInfor,
      openUpdateInfordialog,
      closeUpdateInfordialog,
      dialogUpdateInforCompany,
    };
  },

  components : {
    Snackbar,
    FormHeader,
  },
})
